import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FORCE,
  CHECK_AUTHENTICATED,
  FORGOT_PW,
  FORGOT_PW_SUCCESS,
  FORGOT_PW_FAILURE,
  VERIFICATION_CODE_ENTERED,
  NEW_PW_ENTERED,
  NEW_PW_ENTERED_SUCCESS,
  NEW_PW_ENTERED_FAILURE,
  LOGIN_CHANGE_SCREEN,
  RESEND_VERIFICATION_EMAIL,
  RESEND_VERIFICATION_EMAIL_SUCCESS,
  RESEND_VERIFICATION_EMAIL_FAILURE,
} from './actionTypes';

export const loginAction = credentials => ({
  type: LOGIN,
  credentials,
});

export const loginSuccess = userInfo => ({
  type: LOGIN_SUCCESS,
  userInfo,
});

export const loginFailure = errMsg => ({
  type: LOGIN_FAILURE,
  errMsg,
});

export const logoutAction = accessToken => ({
  type: LOGOUT,
  accessToken,
});

export const logoutSuccessAction = msg => ({
  type: LOGOUT_SUCCESS,
  msg,
});

export const logoutForceAction = msg => ({
  type: LOGOUT_FORCE,
  msg,
});

export const checkAuthenticatedAction = (accessToken, noNotification) => ({
  type: CHECK_AUTHENTICATED,
  accessToken,
  noNotification,
});

export const forgotPwAction = credentials => ({
  type: FORGOT_PW,
  credentials,
});

export const forgotPwSuccess = codeDeliveryDetails => ({
  type: FORGOT_PW_SUCCESS,
  codeDeliveryDetails,
});

export const forgotPwFailure = errMsg => ({
  type: FORGOT_PW_FAILURE,
  errMsg,
});

export const verificationCodeAction = verificationCode => ({
  type: VERIFICATION_CODE_ENTERED,
  verificationCode,
});

export const newPwAction = newPw => ({
  type: NEW_PW_ENTERED,
  newPw,
});

export const newPwSuccess = message => ({
  type: NEW_PW_ENTERED_SUCCESS,
  message,
});

export const newPwFailure = errMsg => ({
  type: NEW_PW_ENTERED_FAILURE,
  errMsg,
});

export const changeLoginScreenAction = newScreen => ({
  type: LOGIN_CHANGE_SCREEN,
  newScreen,
});

export const resendVerificatonEmail = email => ({
  type: RESEND_VERIFICATION_EMAIL,
  email,
});

export const resendVerificatonEmailSuccess = () => ({
  type: RESEND_VERIFICATION_EMAIL_SUCCESS,
});

export const resendVerificatonEmailFailure = () => ({
  type: RESEND_VERIFICATION_EMAIL_FAILURE,
});
